module.exports = __webpack_public_path__ + "static/media/corporate-services-img63.a3ba87ab.jpg";